import { makeStyles } from "@material-ui/core/styles";
import { changeAppState } from "../../../../../common/appState";
import { getLinkText } from "../../../../zApps/Layout/Login/MyPage/Fields/BioField/BioLinks/getLinkText";
import { ATargetBlank } from "../../../Link/ATargetBlank";
import { Markdown } from "../../../Markdown";
import { OtherUser } from "../../types";
import { AlternativeAvatar } from "./AlternativeAvatar";
import { FriendButtonArea } from "./FriendButtonArea/FriendButtonArea";

type Props = {
    targetUser: OtherUser;
    imageSrc: string;
    isMyself: boolean;
    isVeryNarrow: boolean;
};
export function SmartPhoneContent({
    targetUser,
    imageSrc,
    isMyself,
    isVeryNarrow,
}: Props) {
    const c = useStyles();
    return (
        <div>
            <div className={c.imgContainer}>
                {imageSrc ? (
                    <img
                        src={imageSrc}
                        alt={targetUser.name}
                        title={targetUser.name}
                        className={c.img}
                        onClick={() => {
                            changeAppState("imageDetailPanelState", {
                                open: true,
                                src: imageSrc.replace("width300", "width600"),
                            });
                        }}
                    />
                ) : (
                    <div className="fullWidth center">
                        <AlternativeAvatar
                            targetUser={targetUser}
                            isMyself={isMyself}
                        />
                    </div>
                )}
            </div>
            <div
                className={
                    isVeryNarrow
                        ? c.spNarrowMessageContainer
                        : c.spMessageContainer
                }
            >
                <Markdown
                    style={{
                        textAlign: "left",
                        margin: isVeryNarrow ? "5px 0" : 5,
                        fontSize: isVeryNarrow ? "medium" : undefined,
                    }}
                    source={targetUser.bio}
                />
                {targetUser.bioLinks.length > 0 && (
                    <>
                        <ul>
                            {targetUser.bioLinks.map(l => (
                                <li key={l.url}>
                                    <ATargetBlank href={l.url}>
                                        {getLinkText(l.title, l.url)}
                                    </ATargetBlank>
                                </li>
                            ))}
                        </ul>
                        {!isMyself && <hr />}
                    </>
                )}
            </div>
            {!isMyself && (
                <FriendButtonArea
                    style={{ marginTop: 10 }}
                    targetUser={targetUser}
                    isSmartPhone
                />
            )}
        </div>
    );
}
const useStyles = makeStyles(theme => ({
    greeting: {
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "x-large",
        margin: "15px 5px 25px",
    },
    imgContainer: { margin: "0 auto 20px" },
    img: {
        width: "100%",
        maxWidth: 300,
        objectFit: "contain",
        margin: "auto",
        cursor: "pointer",
        boxShadow: `0 0 3px ${theme.palette.grey[400]}`,
    },
    spMessageContainer: {
        margin: 10,
        fontSize: "large",
        textAlign: "left",
        padding: 10,
    },
    spNarrowMessageContainer: {
        margin: "10px 0",
        fontSize: "large",
        textAlign: "left",
        padding: 0,
    },
    spGreeting: {
        fontWeight: "bold",
        fontSize: "x-large",
        margin: "0 5px 25px",
    },
    spNarrowGreeting: {
        fontWeight: "bold",
        fontSize: "x-large",
        margin: "0 0 25px",
    },
}));
